<mat-form-field>
  <mat-select placeholder="Therapie" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let therapy of therapies" [value]="therapy.id">
      {{therapy.displayName}}
    </mat-option>
  </mat-select>
</mat-form-field>
